import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})
export class AuthenticationComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() {

  }


  ngOnInit(): void {
  }

  requestData = `
  curl 'https://api.optimusdrive.ai/v1/storage/connect' \ -H 'authorization: XXX' \ --data-raw 
  '{ 
     "storage_type": "oci", 
     "oci_request": {
      "tenancy_ocid":"ocidd.dq",
      "user_ocid":"ocid1.user.34ic3rma",
      "fingerprint":"df:29:c7:60:ba:94:5e:6f:df:12:fa:8f:32:73:fe:97",
      "region":"us-ashburn-1","bucket_name":"cmw-optimus-video-bucket",
      "namespace":"idyveq4rx",
      "private_key":"-----BEGIN PRIVATE KEY----- \ r \ nMIIjV \ r \ n
      -----END PRIVATE KEY-----"
    }
  }' 
  `

  responseData = `{
  "data":null,
  "message":"OCI connected successfully"
}`



  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


}
